import { defineComponent as _defineComponent } from 'vue'
import EmptyStateEntry from '@/ui/pages/EmptyStateEntry';
  import { Button } from '@/ui/components/Button';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EntityTypeItemsEmpty',
  props: {
    typeId: {
      type: Number,
      required: true,
    },
  },
  setup(__props) {

  

return { __sfc: true,EmptyStateEntry, Button }
}

})